import merge from 'lodash/merge';
import Reference from './types/Reference';
import DomainResource from './DomainResource';

export default class BN_PayorChecklist extends DomainResource {
    static __className = 'BN_PayorChecklist';

    __objectStructure = {
        payor: Reference,
        insertTaxonomy: Boolean,
        payorAlignment: Boolean,
        zeroDollarService: Boolean,
        printDatesRemaining: Boolean,
        printDateBox: Boolean,
        printPayments: Boolean,
        printQualifiers: Boolean,
        boxFourteenNoqualifier: Boolean,
        boxFourteenBlankBox: Boolean,
        boxFifteenNoQualifiers: Boolean,
        boxFifteenBlankBox: Boolean,
        ICDdecimal: Boolean,
        ICDsqueeze: Boolean,
    };

    constructor(constructJson, className = 'BN_PayorChecklist') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
